/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rating: NonNullable<unknown> }} Account_Reviews_RatingInputs */

const he_account_reviews_rating = /** @type {(inputs: Account_Reviews_RatingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rating} מתוך 5`)
};

const en_account_reviews_rating = /** @type {(inputs: Account_Reviews_RatingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rating} out of 5`)
};

/**
* | output |
* | --- |
* | "{rating} out of 5" |
*
* @param {Account_Reviews_RatingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_rating = /** @type {((inputs: Account_Reviews_RatingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_RatingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_rating(inputs)
	return en_account_reviews_rating(inputs)
});